const PostPlaceload = () => {
    return (
        <div className="placeload post-placeload">
            <div className="header">
                <div className="img loads"></div>
                <div className="header-content">
                    <div className="content-shape loads"></div>
                    <div className="content-shape loads"></div>
                </div>
            </div>
            <div className="image-placeholder loads"></div>
            <div className="placeholder-footer">
                <div className="footer-block">
                    <div className="img loads"></div>
                    <div className="inner-wrap">
                        <div className="content-shape loads"></div>
                        <div className="content-shape loads"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PostPlaceload;
